import ReferentListResourcePagingResultModel from '../../generated/types/model/resource/ReferentListResourcePagingResultModel';
import ISchedulerList from '../interfaces/ISchedulerList';
import BaseSchedulerListMixin from '../mixin/BaseSchedulerListMixin';

export default class ReferentListResourcePagingResultViewModel extends BaseSchedulerListMixin(ReferentListResourcePagingResultModel) implements ISchedulerList {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
